import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import HospitalVisitSelect from '../06_incurr_trms/HospitalVisitSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';

const TrmsAccident = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30 + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: 'ALL',
    });

    const [desc, setDesc] = useState('');

    const searchParamsAdditional = { userAuth: localStorage.getItem("userAuth"), };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['기관명', 'ISS', '전체', '교통사고-자동차', '교통사고-자전거', '교통사고-오토바이', '교통사고-기타', '교통사고-미상', '추락', '미끄러짐', '부딪힘', '총상', '베임, 찔림', '기계', '익수', '질식', '화상', '기타', '미상']; //component화 
    const dataColumn = ['TRMSEMNM', 'ISS_DIV', 'ACKN_TOTAL', 'ACKN1_CNT', 'ACKN2_CNT', 'ACKN3_CNT', 'ACKN4_CNT', 'ACKN9_CNT', 'ACKN10_CNT', 'ACKN11_CNT', 'ACKN12_CNT', 'ACKN20_CNT', 'ACKN21_CNT', 'ACKN30_CNT', 'ACKN40_CNT', 'ACKN50_CNT', 'ACKN60_CNT', 'ACKN88_CNT', 'ACKN99_CNT'];
    const apiCall = '/trmsapi/patientstat/bdtongtrms_stat_accident_search.do';
    const apiCntCall = '';
    const excelFileName = `${desc || '전체'}_외상환자 사고종류별 현황`;
    const excelHead = [];
    const mergeConfig = [{ key: 'TRMSEMNM', row: null }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="24%" />
                        <col width="10%" />
                        <col width="18%" />
                        <col width="10%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <HospitalVisitSelect
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setDesc={setDesc}
                            />
                        </tr>
                        <tr>
                            <th>환자분류</th>
                            <td>
                                <select id="searchCheck1"
                                    name="searchCheck1"
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="2">응급센터</option>
                                    <option value="1">외상센터</option>
                                </select>
                            </td>
                            <th>성별</th>
                            <td>
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    <option value="ALL">전체</option>
                                    <option value="M">남자</option>
                                    <option value="F">여자</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <p> * 외상등록체계 전송 대상자 중 ‘외상환자 제외’ 및 ‘연동 후 제외’, ‘외상 삭제’ 제외 </p>
            <p> * 20.1.1. 지침 변경으로 인해 ‘화상’ 코드 신설 및 ‘총상’ 코드 미전송 </p>
        </Main>
    )
}

export default TrmsAccident;